import "./GumTreatments.module.css";
import Header from "@/reusable_sections/Header";
import TheAdvantage from "./sections/TheAdvantage";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import DesignShowcase from "./sections/DesignShowcase";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function GumTreatmentsPage() {
  return <div>
      <Header />
      <TheAdvantage />
      <Projects />
      <FrequentlyAskedQuestions />
      <DesignShowcase />
      <Footer />
    </div>;
}